import { havingDeletePermission, havingEditPermission } from "@/utility/common";
import { GetCommonDeleteImgButton, GetCommonEditImgButton } from "@/components/Images/CommonImages";


type deleteType = (
  modalShow: boolean,
  userId: string,
  userName: string
) => void;

const useCellRenderers = (handleDelete: deleteType,UserCaseGroup:string[]) => {
  const caseRenderers = {
		actionCellRenderers: function (params: any) {
			return (
        <>
          {havingDeletePermission(UserCaseGroup) && 
          <GetCommonDeleteImgButton 
          onClick={() =>
            handleDelete(true, params.data.userCaseId, params.data.userName)
          }
          ></GetCommonDeleteImgButton>
          // <div className="motif-col-md-4">
          //   <CommonTooltipWrapper tooltipTitle={t("global.globalActions.delete")}>
          //   <MotifButton
          //     size="small"
          //     variant={DELETE_IMG_VARIANT}
          //     type="button"
          //     onClick={() =>
          //       handleDelete(true, params.data.userCaseId, params.data.userName)
          //     }
          //   >
          // {getCommonDeleteImg()}
          // </MotifButton>
          // </CommonTooltipWrapper>
          // </div>
          }
          {havingEditPermission(UserCaseGroup) && 
          <GetCommonEditImgButton onClick={() => {
            params.api.startEditingCell({
              rowIndex: params.rowIndex,
              colKey: "role",
            });
          }}></GetCommonEditImgButton>
          // <div className="motif-col-lg-4">
          //   <CommonTooltipWrapper tooltipTitle={t("global.globalActions.edit")}>
          //   <MotifButton
          //     onClick={() => {
          //       params.api.startEditingCell({
          //         rowIndex: params.rowIndex,
          //         colKey: "role",
          //       });
          //     }}
          //     size="small"
          //     type="button"
          //     variant={EDIT_IMG_VARIANT}
          //   >
          //    {getCommonEditImg()}
          //   </MotifButton>
          // </CommonTooltipWrapper>
          // </div>
          }
        </>
      );
		},
	};
	return caseRenderers;
};
export default useCellRenderers;
